/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import React from 'react';
import Promise from 'bluebird';
import _ from 'underscore';

// eslint-disable-next-line no-restricted-modules
const parseUrl = require('url-parse');

import { Analytics, getScreenFromUrl } from '@trello/atlassian-analytics';
import { getSmartCardAppearanceFromTitle } from '@trello/smart-card';
import { PLAIN_LINK_TITLE } from '@trello/editor';

import { KnownServices } from 'app/scripts/db/known-services';
import { ModelCache } from 'app/scripts/db/model-cache';
import { pluginRunner } from 'app/scripts/views/internal/plugins/PluginRunner';
import { sendPluginTrackEvent } from 'app/scripts/lib/plugins/plugin-behavioral-analytics';
import { SmartLinksBridge } from 'app/scripts/views/internal/smart-links-bridge';
import { renderComponent } from 'app/src/components/ComponentWrapper';
import { teacupWithHelpers } from 'app/scripts/views/internal/teacupWithHelpers';

const t = teacupWithHelpers();

const formatCache = new window.Map();
const formatRequestCache = new window.Map();

const generateFriendlyLinkAnalyticsPayload = (application, meta) => ({
  application,
  resourceType: meta?.resolvedUrl?.meta?.resourceType,
  visibility: meta?.resolvedUrl?.meta?.visibility,
});

const handleFriendlyLinkClick = ({ application, meta }) => {
  Analytics.sendClickedLinkEvent({
    linkName: 'friendlyLink',
    source: getScreenFromUrl(),
    attributes: generateFriendlyLinkAnalyticsPayload(application, meta),
  });
};

const handleFriendlyLinkRender = ({ application, meta }) => {
  Analytics.sendOperationalEvent({
    action: 'rendered',
    actionSubject: 'friendlyLink',
    source: getScreenFromUrl(),
    attributes: generateFriendlyLinkAnalyticsPayload(application, meta),
  });
};

const template = t.renderable(function ({ icon, text, idPlugin, monochrome }) {
  t.img({
    class: t.classify({
      'known-service-icon': true,
      'plugin-icon': idPlugin != null,
      'mod-reset': monochrome === false,
    }),
    src: icon,
  });
  return t.text(text);
});

export const friendlyLinks = function (el, board, options = {}) {
  const els =
    el && el.tagName === 'A' ? [el] : _.toArray(el.querySelectorAll('a'));

  return Promise.map(els, function (el) {
    // The URL serializer in HTMLHyperlinkElementUtils.href
    // (https://url.spec.whatwg.org/#concept-url-serializer) appends a slash
    // to the base url e.g. <a href="http://www.trello.com">Trello</a>
    // will return http://www.trello.com/. Unfortunately, this breaks any
    // comparison we make with the link's actual text node if the URL supplied
    // is a base URL with no trailing slash.
    const parsedUrl = parseUrl(el.href);
    const url =
      el.textContent === parsedUrl.origin ? parsedUrl.origin : parsedUrl.href;
    const title = el.getAttribute('title');

    // If the link already has custom text, leave it alone.
    if (url !== el.textContent) {
      // In some cases, the href is escaped and the textContent
      // isn't, so also check against the decoded url.
      try {
        const decoded = decodeURIComponent(url);
        if (decoded !== el.textContent) {
          // Neither the original URL nor the decoded URL match the
          // text, assume they have custom text and don't change it
          return;
        }
      } catch (ignored) {
        // Don't worry if the URL can't be decoded and assume they've
        // got custom text
        return;
      }
    }

    // Editor sets the titles of plain link to a zero-width, non-joiner
    // character. If the link has this title, we want to return early,
    // so we don't render this as an inline Smart Card by default.
    // Also removing the title so that browsers don't try to show an
    // empty tooltip for these links.
    if (title === PLAIN_LINK_TITLE) {
      el.removeAttribute('title');
      return;
    }

    const appearance = getSmartCardAppearanceFromTitle(title);
    if (appearance) {
      el.removeAttribute('title');
    }

    const cacheKey = `${board != null ? board.id : undefined}:${url}`;

    return Promise.try(function () {
      if (!board) {
        throw new pluginRunner.Error.NotHandled('no board specified');
      }

      if (formatCache.get(cacheKey)) {
        return formatCache.get(cacheKey);
      }

      if (formatRequestCache.get(cacheKey)) {
        return formatRequestCache.get(cacheKey);
      }

      const formatRequest = pluginRunner.one({
        command: 'format-url',
        board,
        options: {
          url,
        },
      });

      formatRequestCache.set(cacheKey, formatRequest);
      return formatRequest;
    })
      .catch(pluginRunner.Error.NotHandled, () => null)
      .then(function (pluginResult) {
        formatRequestCache.delete(cacheKey);
        if ((pluginResult != null ? pluginResult.text : undefined) != null) {
          // there might not be an idPlugin because we are attaching a trello card
          // not a link that is being formatted by a power-up
          if (pluginResult.idPlugin) {
            sendPluginTrackEvent({
              idPlugin: pluginResult.idPlugin,
              idBoard: board.id,
              event: {
                action: 'formatted',
                actionSubject: 'url',
                source: 'powerUpFormatUrl',
              },
            });
          }

          return pluginResult;
        } else {
          return KnownServices.interpret(el.href, ModelCache, {
            sourceComponent: 'atlaskit-smart-card',
          });
        }
      })
      .then(function (known) {
        if (known != null) {
          formatCache.set(cacheKey, known);
          // resolved data comes from KnownServices.interpret
          if (known.url) {
            el.classList.add('atlaskit-smart-link');
            return renderComponent(
              React.createElement(SmartLinksBridge, {
                url: known.url,
                appearance,
                analyticsContext: options.analyticsContext,
              }),
              el,
            );
          }
          // else from pluginResult
          el.classList.add('known-service-link');
          handleFriendlyLinkRender(known);
          el.addEventListener('click', handleFriendlyLinkClick(known));
          return (el.innerHTML = template(known));
        }
      });
  });
};
